import { render, staticRenderFns } from "./Accountform.vue?vue&type=template&id=97ab19e0&"
import script from "./Accountform.vue?vue&type=script&lang=js&"
export * from "./Accountform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports